import React from 'react';
import { array, func, object, number } from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { getPackageTypeById, hasRecommendedPackage, isRecommendedPackage } from '../../../utils/packagesUtils';
import TabContent from '../TabContent';
import CheckoutFormHOC from '../../shared/CheckoutFormHOC';
import { selectPackage } from '../../../actions/packages';
import { PACKAGE_POSITIONS } from '../../../types/packagePositions';
import { reportTabClickEvents } from './utils';

import './style.scss';

const TriplePackage = (
    { packageList, selectedPackageId, onComparePackagesClick, selectPackage },
    { biEvents }
) => {
    const className = classnames('packages-tabs', 'triple', {
        'recommended': hasRecommendedPackage(packageList)
    });

    const onPackageChange = (id) => {
        selectPackage({ packageId: id });
        reportTabClickEvents(biEvents, id);
    };

    return (
        <div className={className}>
            {packageList.map(({ id }) => (
                <input key={id} id={`package-tab-${id}`} name="package-tab-group"
                    type="radio" checked={selectedPackageId === id}/>
            ))}

            <div className="nav-container">
                {packageList.map(({ id }) => (
                    <label key={id} htmlFor={`package-tab-${id}`}
                        onClick={() => onPackageChange(id)}>
                        <I18n k={getPackageTypeById(id)}/>
                    </label>
                ))}
            </div>

            <div className="tabs-content">
                {packageList.map((packageData) => {
                    const { id } = packageData;
                    const className = classnames('content', { 'recommended': isRecommendedPackage(packageData) });

                    return (
                        <CheckoutFormHOC key={id} className={className} selectedPackageId={id}
                            source={PACKAGE_POSITIONS.TABS}>
                            <TabContent id={id} onComparePackagesClick={onComparePackagesClick}/>
                        </CheckoutFormHOC>
                    );
                })}
            </div>
        </div>
    );
};

TriplePackage.propTypes = {
    packageList: array,
    selectedPackageId: number,
    onComparePackagesClick: func
};

TriplePackage.contextTypes = {
    biEvents: object
};

const mapStateToProps = ({ packages }, { onComparePackagesClick }) => ({
    packageList: packages.packageList,
    selectedPackageId: packages.selectedPackageId,
    onComparePackagesClick
});

export { TriplePackage };
export default connect(mapStateToProps, { selectPackage })(TriplePackage);
